import _typeof from "@babel/runtime/helpers/esm/typeof";
import { getCookie, setCookie } from "./cookie";
var config = {};
var queue = [];
function setData() {
  setCookie('iwp_task_id', '');
  setCookie('iwp_gateway', '');
}
function getData() {
  var iwp_task_id = '';
  var iwp_gateway = '';
  if (typeof window !== 'undefined') {
    iwp_task_id = getCookie('iwp_task_id') || '';
    iwp_gateway = getCookie('iwp_gateway') || '';
  }
  config = {
    iwp_task_id: iwp_task_id,
    iwp_gateway: iwp_gateway
  };
}
function removeData() {
  var _document;
  if (typeof ((_document = document) === null || _document === void 0 ? void 0 : _document.cookie) === 'string') {
    setCookie('iwp_task_id', '', -1000);
    setCookie('iwp_gateway', '', -1000);
  }
}
function request(opt) {
  var _window, _window2;
  var url = opt.url,
    method = opt.method,
    headers = opt.headers,
    data = opt.data;
  var isMock = (_window = window) === null || _window === void 0 ? void 0 : _window.isMock; // mock的场景，使用浏览器的上报
  var payload = Object.keys(data).reduce(function (concatedStr, key) {
    return concatedStr + "".concat(key, "=").concat(encodeURIComponent(data[key]), "&");
  }, '');
  payload = payload.slice(0, -1);
  if (typeof window.AlipayJSBridge !== 'undefined' && typeof window.AlipayJSBridge.call === 'function' && !isMock) {
    var params = {
      url: url,
      data: payload,
      method: method,
      headers: headers
    };
    if (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string') {
      var ua = navigator.userAgent;
      if (!/android/i.test(ua)) {
        params.headers = headers;
      }
    }
    window.AlipayJSBridge.call('httpRequest', params);
  } else if ((_window2 = window) !== null && _window2 !== void 0 && _window2.XMLHttpRequest) {
    var xhr = new window.XMLHttpRequest();
    xhr.open(method, url);
    for (var key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
    xhr.send(payload);
  } else {
    Object.keys(data).forEach(function (key) {
      try {
        data[key] = decodeURIComponent(data[key]);
      } catch (e) {
        console.log(e);
      }
    });
  }
}
function report(content, subType) {
  var str = content;
  var obj = {};
  var now = Date.now() + '';
  if (Array.isArray(content)) {
    obj = {
      ts: now,
      content: JSON.stringify(content)
    };
  } else if (_typeof(content) !== 'object') {
    try {
      obj = {
        ts: now,
        content: String(str)
      };
    } catch (e) {
      str = 'encodeURIComponent error';
    }
  } else {
    obj = content;
    obj.ts = now;
  }
  try {
    str = JSON.stringify(obj);
  } catch (e) {
    str = 'parse json error';
  }
  if (typeof str === 'string') {
    queue.push(str);
  }
  var time = new Date().getTime();
  if (config.iwp_expire_date === '1') {
    queue = [];
    removeData();
    return;
  }
  if (config.iwp_expire_date && time > Number(config.iwp_expire_date)) {
    queue = [];
    removeData();
    return;
  }
  if (!config.iwp_task_id || !config.iwp_gateway) {
    queue = [];
    return;
  }
  if (typeof config.iwp_task_id !== 'string') return;
  var url = "".concat(config.iwp_gateway, "log/report");
  var headers = {
    'Content-type': 'application/x-www-form-urlencoded'
  };
  while (queue.length > 0) {
    var localContent = queue.shift();
    if (typeof localContent !== 'string') continue;
    var data = {
      task_id: config.iwp_task_id,
      type: 'h5',
      sub_type: subType,
      content: localContent,
      ts: now
    };
    request({
      url: url,
      method: 'POST',
      headers: headers,
      data: data
    });
  }
}
function log(arg1) {
  for (var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    otherArgs[_key - 1] = arguments[_key];
  }
  report([arg1].concat(otherArgs), 'console');
}
function info(arg1) {
  for (var _len2 = arguments.length, otherArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    otherArgs[_key2 - 1] = arguments[_key2];
  }
  report([arg1].concat(otherArgs), 'console');
}
function error(arg1) {
  for (var _len3 = arguments.length, otherArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    otherArgs[_key3 - 1] = arguments[_key3];
  }
  report([arg1].concat(otherArgs), 'console');
}
var _console = {
  log: log,
  info: info,
  error: error
};
getData();
export var helper = {
  setData: setData,
  getData: getData,
  removeData: removeData,
  console: _console,
  report: report
};